module.exports = __webpack_public_path__ + "img/20191204172151360截图20191204163938480.5b85cdd9.jpg";